/**
 * Узкий экран — телефон: сайдбар уступает место таб-бару, доска показывает по
 * одной колонке (макеты 27:2, 28:61, 28:107).
 *
 * Граница одна на всё приложение: разъехавшиеся брейкпоинты в CSS и в логике
 * дают экран, где таб-бар уже появился, а доска ещё в четыре колонки.
 */
import { onUnmounted, ref, type Ref } from 'vue'

export const MOBILE_WIDTH = 768

export const useIsMobile = (): Ref<boolean> => {
  const isMobile = ref(false)

  if (typeof window === 'undefined' || !window.matchMedia) return isMobile

  const query = window.matchMedia(`(max-width: ${MOBILE_WIDTH}px)`)
  const sync = () => {
    isMobile.value = query.matches
  }

  sync()
  query.addEventListener('change', sync)

  onUnmounted(() => query.removeEventListener('change', sync))

  return isMobile
}
